import type { ReactNode } from "react";
import type { HubAgent } from "../lib/api";
import type { Theme } from "../lib/appearance";
import { OwnerNavigation } from "./OwnerNavigation";
import { ThemeSwitch } from "./StudioChrome";
import { LoadingState } from "./ui";

/** Stable chrome while identity and entry state are read; no previous Agent data. */
export function LoadingShell({ label, accountName, embedded = false, agents = null, currentAgent, appearance, children }: {
  label: string; accountName?: string; embedded?: boolean;
  /**
   * The Hub's directory, when this shell has already read it. The tree says
   * 正在读取 Agent… without it, which was true of every one of these pages until
   * one of them could be drawn from the directory alone (D681).
   */
  agents?: HubAgent[] | null; currentAgent?: string | null;
  /**
   * The studio's one appearance choice, where this shell is a page somebody
   * sits on rather than a moment between two of them -- a stopped Agent is
   * read until its Owner does something about it. 「一处控制，每一页都够得着」
   * (D654) is false for a page of the studio with no control in its header, so
   * the chips are here too; a shell given no choice to offer draws none.
   */
  appearance?: { value: Theme; onChange: (theme: Theme) => void };
  children?: ReactNode;
}) {
  if (embedded) return <main className="embedded-loading">{children || <LoadingState label={label} />}</main>;
  return <div className="app app-loading"><OwnerNavigation agents={agents} currentAgent={currentAgent} accountName={accountName || "正在确认账号"} connected={false} />
    <div className="body"><header className="top"><span className="top-title">涟漪</span>
      {appearance ? <ThemeSwitch theme={appearance.value} onPick={appearance.onChange} /> : null}</header>
      <main className="main workspace-loading">{children || <><LoadingState label={label} /><div className="workspace-loading-lines" aria-hidden="true"><span /><span /><span /></div></>}</main>
    </div>
  </div>;
}
